<template>
    <a class="link yellow pointer" @click="$emit('click')">
        <h6 class="flex items-center">
            <span class="grow">
                <img v-if="addCaret" class="mr2" src="@/assets/img/icon_back_simple_yellow.svg"/>
                <slot></slot>
            </span>
        </h6>
    </a>
</template>

<script>
export default {
    props: {
        addCaret: {
            type: Boolean,
            default: true
        }
    }
};
</script>
